/* ============================================================
   Kasuwa theme — product page interactions.
   Variant picker with price, compare-at, unit price and sold-out
   updates. Gallery media switching on variant selection.
   Pickup availability refresh. Share copy link.
   Complementary product recommendations.
   Dependency-free, non-minified.
   ============================================================ */
(function () {
  'use strict';

  /* Guard: the script tag is included by every product section,
     but the logic must only bind once per page. */
  if (window.KWProductLoaded) return;
  window.KWProductLoaded = true;

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.KW && window.KW.currency) || 'USD'
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Gallery: show one media, mark its thumbnail ---------- */
  function showMedia(root, mediaId) {
    var main = root.querySelector('[data-kw-gallery-main]');
    if (!main) return;
    var found = false;
    main.querySelectorAll('[data-kw-media-id]').forEach(function (el) {
      var match = String(el.getAttribute('data-kw-media-id')) === String(mediaId);
      el.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;
    var thumbs = root.querySelector('[data-kw-gallery-thumbs]');
    if (thumbs) {
      thumbs.querySelectorAll('[data-kw-thumb]').forEach(function (btn) {
        btn.classList.toggle(
          'is-active',
          String(btn.getAttribute('data-kw-thumb')) === String(mediaId)
        );
      });
    }
  }

  /* ---------- Price, compare-at, unit price and sold-out ---------- */
  function renderVariantState(root, variant) {
    var priceEl = root.querySelector('[data-kw-price]');
    if (priceEl) {
      var showCompare = priceEl.getAttribute('data-kw-show-compare') !== 'false';
      var html = money(variant.price);
      if (showCompare && variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="kw-product__compare">' + money(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }

    var unitWrap = root.querySelector('[data-kw-unit-price]');
    if (unitWrap) {
      var measurement = variant.unit_price_measurement;
      if (measurement && variant.unit_price != null) {
        var ref = measurement.reference_value && measurement.reference_value !== 1
          ? measurement.reference_value
          : '';
        var valueEl = unitWrap.querySelector('[data-kw-unit-value]');
        if (valueEl) {
          valueEl.textContent = money(variant.unit_price) + '/' + ref + (measurement.reference_unit || '');
        }
        unitWrap.hidden = false;
      } else {
        unitWrap.hidden = true;
      }
    }

    var soldout = root.querySelector('[data-kw-soldout]');
    if (soldout) soldout.hidden = !!variant.available;

    var btn = root.querySelector('[data-kw-add-to-cart]');
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available
        ? btn.getAttribute('data-kw-add-label')
        : btn.getAttribute('data-kw-sold-out-label');
    }
  }

  function markUnavailable(root) {
    var btn = root.querySelector('[data-kw-add-to-cart]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-kw-unavailable-label') || 'Unavailable';
    }
  }

  /* ---------- Pickup availability: toggle + per-variant refresh ---------- */
  function bindPickupToggle(scope) {
    scope.querySelectorAll('[data-kw-pickup-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var list = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!list) return;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        list.hidden = expanded;
      });
    });
  }

  function refreshPickup(root, variantId) {
    var wrap = root.querySelector('[data-kw-pickup]');
    if (!wrap) return;
    fetch(window.location.pathname + '?variant=' + variantId, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kw-pickup]');
        wrap.innerHTML = fresh ? fresh.innerHTML : '';
        bindPickupToggle(wrap);
      })
      .catch(function () {});
  }

  /* ---------- One product section (main or featured) ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-kw-product-json]');
    var product = null;
    try {
      product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    } catch (e) {
      product = null;
    }
    if (!product || !product.variants || !product.variants.length) return;

    var idInput = root.querySelector('[data-kw-variant-id]');
    var picker = root.querySelector('[data-kw-variant-picker]');

    /* Gallery thumbnails always work, even without a variant picker. */
    var thumbs = root.querySelector('[data-kw-gallery-thumbs]');
    if (thumbs) {
      thumbs.querySelectorAll('[data-kw-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          showMedia(root, btn.getAttribute('data-kw-thumb'));
        });
      });
    }

    /* Share: copy link to clipboard. */
    root.querySelectorAll('[data-kw-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-kw-copy-link');
        function done() {
          var note = btn.parentElement.querySelector('[data-kw-copy-done]');
          if (note) note.hidden = false;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });

    bindPickupToggle(root);

    if (!picker) return;

    function selectedOptions() {
      return product.options.map(function (option, index) {
        var checked = picker.querySelector('[data-kw-option-input="' + index + '"]:checked');
        if (checked) return checked.value;
        var select = picker.querySelector('[data-kw-option-select="' + index + '"]');
        return select ? select.value : null;
      });
    }

    function findVariant() {
      var opts = selectedOptions();
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && variant['option' + (j + 1)] !== opts[j]) {
            match = false;
            break;
          }
        }
        if (match) return variant;
      }
      return null;
    }

    function applyVariant(variant) {
      if (!variant) {
        markUnavailable(root);
        return;
      }
      if (idInput) idInput.value = variant.id;
      renderVariantState(root, variant);
      product.options.forEach(function (option, index) {
        var label = picker.querySelector('[data-kw-option-value="' + index + '"]');
        if (label && variant['option' + (index + 1)]) {
          label.textContent = variant['option' + (index + 1)];
        }
      });
      if (variant.featured_media && variant.featured_media.id) {
        showMedia(root, variant.featured_media.id);
      }
      refreshPickup(root, variant.id);
    }

    picker.querySelectorAll('[data-kw-option-input]').forEach(function (input) {
      input.addEventListener('change', function () { applyVariant(findVariant()); });
    });
    picker.querySelectorAll('[data-kw-option-select]').forEach(function (select) {
      select.addEventListener('change', function () { applyVariant(findVariant()); });
    });
  }

  /* ---------- Complementary products: fetch with intent=complementary ---------- */
  function initComplementary(wrap) {
    var url = wrap.getAttribute('data-kw-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-kw-complementary]');
        if (fresh && fresh.innerHTML.trim() !== '') {
          wrap.innerHTML = fresh.innerHTML;
        } else {
          wrap.hidden = true;
        }
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-kw-product]').forEach(initProduct);
    document.querySelectorAll('[data-kw-complementary]').forEach(initComplementary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
